import { render, staticRenderFns } from "./addfooter.vue?vue&type=template&id=59ed6d74&"
import script from "./addfooter.vue?vue&type=script&lang=js&"
export * from "./addfooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59ed6d74')) {
      api.createRecord('59ed6d74', component.options)
    } else {
      api.reload('59ed6d74', component.options)
    }
    module.hot.accept("./addfooter.vue?vue&type=template&id=59ed6d74&", function () {
      api.rerender('59ed6d74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/components/addfooter.vue"
export default component.exports